// Exactly 1440 keeps the legacy layout (task 243: "over 1440px").
export const WIDE_MIN_EXCLUSIVE = 1440;

export const LEGACY_TABS = Object.freeze([
  { key: "chat", label: "Chat" },
  { key: "tasks", label: "Tasks" },
  { key: "timeline", label: "Timeline" },
  { key: "questions", label: "Questions" },
  { key: "decisions", label: "Decisions" },
  { key: "activity", label: "Activity" },
  { key: "spec", label: "Spec" },
  { key: "architecture", label: "Architecture" },
  { key: "mockups", label: "Mockups" },
  { key: "db", label: "DB" },
  { key: "tests", label: "Tests" },
  { key: "diff", label: "Diff" },
  { key: "pr", label: "PR" },
  { key: "preview", label: "Preview" },
  { key: "console", label: "Console" },
  { key: "bridge-debug", label: "Bridge Debug" },
]);

// Task 248: wide tabs live in user-arranged columns; chat is a tab whose own feed scrolls.
export const WIDE_TABS = Object.freeze([
  { key: "chat", label: "Chat", scroll: false },
  { key: "ticket", label: "Ticket" },
  ...LEGACY_TABS.filter(tab => tab.key !== "chat"),
]);

export const MIN_PANE_PX = 360;

// 243's arrangement: chat alone on the left at 45%, everything else beside it with ticket first.
export const DEFAULT_WIDE_LAYOUT = Object.freeze({
  v: 1,
  panes: [
    { id: "p1", size: 0.45, tabs: ["chat"], active: "chat" },
    { id: "p2", size: 0.55, tabs: WIDE_TABS.filter(tab => tab.key !== "chat").map(tab => tab.key), active: "ticket" },
  ],
});

export function isWideViewport(width) {
  return Number(width) > WIDE_MIN_EXCLUSIVE;
}

export function isProjectDetailsPath(path) {
  return /^\/projects\/\d+(\/[a-z][a-z0-9_-]*)?\/?$/i.test(path || "");
}

export function parseTabKey(path) {
  const match = (path || "").match(/^\/projects\/\d+\/([a-z][a-z0-9_-]*)\/?$/i);
  return match ? match[1] : null;
}

// /projects/{id}/chat and /projects/{id}/ticket stay valid URLs at every width.
export function tabForLayout(urlTab, wide) {
  const tabs = wide ? WIDE_TABS : LEGACY_TABS;
  if (urlTab === "ticket" && !wide) {
    return "chat";
  }
  return tabs.some(tab => tab.key === urlTab) ? urlTab : tabs[0].key;
}
